import request from '@/utils/request'

/**
 * 添加地图中心点
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapCenterAdd(data) {
  return request({
    type: 'biz',
    url: 'map/center/add',
    method: 'post',
    data
  })
}

/**
 * 获取当前中心点
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapCenterCurrentGet(data) {
  return request({
    type: 'biz',
    url: 'map/center/current/get',
    method: 'post',
    data
  })
}

/**
 * 获取当前中心点(微信端)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapCenterCurrentNotokenGet(data) {
  return request({
    type: 'biz',
    url: 'map/center/current/notoken/get',
    method: 'post',
    data
  })
}

/**
 * 删除地图中心点
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapCenterDelete(data) {
  return request({
    type: 'biz',
    url: 'map/center/delete',
    method: 'post',
    data
  })
}

/**
 * 获取地图中心点详情
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapCenterGet(data) {
  return request({
    type: 'biz',
    url: 'map/center/get',
    method: 'post',
    data
  })
}

/**
 * 地图中心点管理列表(分页)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapCenterPageListGet(data) {
  return request({
    type: 'biz',
    url: 'map/center/page/list/get',
    method: 'post',
    data
  })
}

/**
 * 修改地图中心点
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapCenterUpdate(data) {
  return request({
    type: 'biz',
    url: 'map/center/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/MapCenter.js